import axios from "axios";
import { apiUrl } from "../config/environment";
import { getAuthHeadersOptional } from "../utils/authUtils";

const apiBase = `${apiUrl}/api/ai`;

export type StartExtractPayload = {
  imageBase64: string;
  labelMode?: boolean;
  enrich?: boolean;
  formMap?: boolean;
};

export async function startExtract(payload: StartExtractPayload): Promise<{ jobId: string }> {
  const res = await axios.post(`${apiBase}/extract-image`, payload, getAuthHeadersOptional());
  return res.data;
}

export type ExtractStatus = {
  status: "queued" | "processing" | "done" | "error";
  data?: { items?: any[]; form?: any; meta?: any };
  error?: string;
};

export async function getStatus(jobId: string): Promise<ExtractStatus> {
  const res = await axios.get(`${apiBase}/extract-status/${jobId}`, getAuthHeadersOptional());
  return res.data;
}

export async function waitForResult(jobId: string, opts: { intervalMs?: number; timeoutMs?: number } = {}) {
  const { intervalMs = 1500, timeoutMs = 60000 } = opts;
  const started = Date.now();

  while (true) {
    const s = await getStatus(jobId);
    if (s.status === "done" || s.status === "error") return s;
    if (Date.now() - started > timeoutMs) {
      return { status: "error", error: "Timed out while analyzing image" };
    }
    await new Promise((r) => setTimeout(r, intervalMs));
  }
}








